const user = [
    {
        path: '/user/manage',
        name: 'commonManage',
        component: () => import('@/view/user/manage'),
    },
    {
        path: '/user/group',
        name: 'commonGroup',
        component: () => import('@/view/user/group'),
    },
    {
        path: '/user/gateway',
        name: 'commonGateway',
        component: () => import('@/view/user/gateway'),
    },
    
]
export default user